import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/camarero-2-enviar-cocina.webp")